import { render, staticRenderFns } from "./PreviewStamp.vue?vue&type=template&id=6e172ee0&scoped=true&"
import script from "./PreviewStamp.vue?vue&type=script&lang=js&"
export * from "./PreviewStamp.vue?vue&type=script&lang=js&"
import style0 from "./PreviewStamp.vue?vue&type=style&index=0&id=6e172ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e172ee0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e172ee0')) {
      api.createRecord('6e172ee0', component.options)
    } else {
      api.reload('6e172ee0', component.options)
    }
    module.hot.accept("./PreviewStamp.vue?vue&type=template&id=6e172ee0&scoped=true&", function () {
      api.rerender('6e172ee0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/shared/PreviewStamp.vue"
export default component.exports